export const sortByOptions = [
  { text: 'Alpha Only', value: 0 },
  { text: 'School / Alpha', value: 1 },
  { text: 'School / Teacher / Alpha', value: 2 },
  { text: 'School / Grade', value: 3 },
  { text: 'Grade / Alpha', value: 4 },
  { text: 'Student Status', value: 5 },
  { text: 'Family Number', value: 6 },
];

export const statusOptionEnum = {
  All: 0,
  Free: 2,
  Reduced: 3,
  Denied: 4,
};

export const statusOptionModelParamMap = {
  [statusOptionEnum.All]: 'StatusAll',
  [statusOptionEnum.Free]: 'StatusFree',
  [statusOptionEnum.Reduced]: 'StatusReduced',
  [statusOptionEnum.Denied]: 'StatusDenied',
};

export const statusOptions = [
  // { text: 'ALL', value: statusOptionEnum.All },
  { text: 'Free (2)', value: statusOptionEnum.Free },
  { text: 'Reduced (3)', value: statusOptionEnum.Reduced },
  { text: 'Denied (4)', value: statusOptionEnum.Denied },
];

export const caseTypeOptions = [
  {
    text: 'Direct Certified (Free)',
    value: 1,
  },
  {
    text: 'Direct Certified (Reduced)',
    value: 2,
  },
  { text: 'HMR/EM Only', value: 3 },
  { text: 'Foster Only', value: 4 },
  { text: 'Head Start Only', value: 5 },
  { text: 'Case Number', value: 6 },
  { text: 'Kin-GAP Only', value: 7 },
];

export const filterMethodEnums = {
  status: 'status',
  caseType: 'caseType',
};

export const statusFilterMethods = [
  { label: 'Status', value: filterMethodEnums.status },
  { label: 'Other Options', value: filterMethodEnums.caseType },
];

export const provisionTypeOptions = [
  { label: 'CEP/Provision 2 Only ', value: '0' },
  { label: 'Traditional', value: '1' },
  { label: 'Both', value: '2' },
];

export const asOfOptions = [
  { label: 'Student Effective Date', value: false },
  { label: 'Application Date', value: true },
];

export const allOption = { value: 'ALL', text: 'ALL', key: 'valueALL' };

export const excelReportFileName = 'MasterRosterReport';



// WEBPACK FOOTER //
// ./src/pages/masterroster/helpers/constants.js